import _ from 'lodash';
import { Component, DestroyRef, inject, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { selectVirtualEventSelectedCampaign, selectVirtualEventSelectedOption, selectVirtualEventData } from '../../features/data/data.selectors';
import { Store, select } from '@ngrx/store';

import { CAMPAIGN_TYPE } from 'app/virtual-event/virtual-event.enums';
import { first, combineAll } from 'rxjs/operators';
import { finalizeVirtualEventAuctionItem, setVirtualEventPresentationMode } from 'app/virtual-event/features/data/data.actions';
import { of } from 'rxjs';
import { selectActiveCampaignList } from 'app/campaign/features/campaign.selectors';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-currently-live-option',
  templateUrl: './currently-live-option.component.html',
  styleUrls: ['./currently-live-option.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CurrentlyLiveOptionComponent implements OnInit {
  destroyRef = inject(DestroyRef)
  public event$: any = this.store.pipe(select(selectVirtualEventData));
  public campaign$: any = this.store.pipe(select(selectVirtualEventSelectedCampaign));
  public option$: any = this.store.pipe(select(selectVirtualEventSelectedOption));
  public list$: any = this.store.pipe(select(selectActiveCampaignList));

  @ViewChild('defaultTemplate', {static: true})
  private defaultTemplateRef: TemplateRef<any>;
  @ViewChild('auctionTemplate', {static: true})
  private auctionTemplateRef: TemplateRef<any>;
  @ViewChild('donateTemplate', {static: true})
  private donateTemplateRef: TemplateRef<any>;
  @ViewChild('lastHeroTemplate', {static: true})
  private lastHeroTemplateRef: TemplateRef<any>;

  public presentingTemplateRef: TemplateRef<any> = null;
  public buttonLabel = "Declare Winner";

  constructor(
    private store: Store<any>
  ) { }

  ngOnInit(): void {
    of(this.event$, this.campaign$, this.option$).pipe(
      combineAll(),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((results) => {
      const event: any = results[0];
      const campaign: any = results[1];
      const option: any = results[2];

      const currentItemType = _.get(event, 'currentItem.currentItemType', 1);
      if(currentItemType === 1) {
        this.presentingTemplateRef = this.defaultTemplateRef;
        this.buttonLabel = 'Declare Winner';
        return;
      }

      switch(campaign.type) {
        case CAMPAIGN_TYPE.AUCTION:
          this.presentingTemplateRef = this.auctionTemplateRef;
          this.buttonLabel = option.soldCount > 0 ? 'Declared': 'Declare Winner';
          break;
        case CAMPAIGN_TYPE.DONATE:
          this.presentingTemplateRef = this.donateTemplateRef;
          this.buttonLabel = 'Declare Winner';
          break;
        case CAMPAIGN_TYPE.LAST_HERO:
          this.presentingTemplateRef = this.lastHeroTemplateRef;
          this.buttonLabel = 'Declare Winner';
          break;
      }
    });
  }

  getContext(campaign, option, list) {
    const { buttonLabel } = this;
    return { campaign, option, list, buttonLabel };
  }

  getImageUrl(option) {
    return option.imageUrl === '' ? '/images/blank-image.png': option.imageUrl;
  }

  finalizeAuctionItem(campaign, option) {
    return this.store.pipe(
      select(selectVirtualEventData),
      first(),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(data => {
      return this.store.dispatch({
        type: finalizeVirtualEventAuctionItem.type,
        payload: {
          vEventId: data.id,
          campaignId: campaign.id,
          option: option
        }
      });
    })
  }

  onSetPresentationMode(presentationMode) {
    return this.store.pipe(
      select(selectVirtualEventData),
      first(),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(data => {
      this.store.dispatch({
        type: setVirtualEventPresentationMode.type,
        payload: {
          eventId: data.id,
          presentationMode
        }
      })
    });
  }

}
